import React from 'react';
import classNames from 'classnames';

export const CommonTable = ({
                              tableProps: {
                                getTableProps,
                                getTableBodyProps,
                                headerGroups,
                                rows,
                                prepareRow,
                              },
                              customTableStyles = '',
                              customHeaderStyles = '',
                              customTableHeadColor = 'custom-brand-color-tableHead',
                              customContainerStyles = '',
                              customContainerID = 'tableContainer',

                            }) => {
  return (
    <div id={customContainerID} className={customContainerStyles}>
      <table
        {...getTableProps()}
        className={classNames(`table table-head-custom table-vertical-center infinite-scroll-table`, customTableStyles)}
      >
        <thead className={classNames('sticky-header', customHeaderStyles)}>
        {headerGroups.map(headerGroup => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map(column => (
              <th {...column.getHeaderProps()} id={customTableHeadColor}
                  className={'pt-4'}>{column.render('Header')}</th>
            ))}
          </tr>
        ))}
        </thead>
        <tbody {...getTableBodyProps()} className="body">
        {rows.map((row, i) => {
          prepareRow(row);
          return (
            <tr {...row.getRowProps()} key={i}>
              {row.cells.map(cell => {
                return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>;
              })}
            </tr>
          );
        })}
        </tbody>
      </table>
    </div>
  );
};
